export const studioStatus = Object.freeze({
    SEND_TEMPLATE: 1,
    TEMPLATE_SENT: 2,
    SEND_ARTWORK: 3,
    ARTWORK_SENT: 4,
    SEND_PROOF: 5,
    PROOF_SENT: 6,
    SEND_MAKE_ARTWORK: 7,
    MAKE_ARTWORK_SENT: 8,
    ARCHIVE: 'archive'
})

export const studioStatusLabels = {
    1: 'Template Request',
    2: 'Sent Template',
    3: 'Create Digital Proof Request',
    4: 'Digital Proof Sent',
    5: 'Update Vendor Proof Request',
    6: 'Vendor Proof Sent',
    7: 'Make Artwork Request',
    8: 'Make Artwork Sent',
    archive: 'Archive'
}

export const getStudioStatusLabel = (status) => {
    return studioStatusLabels[status] || `Status ${status}`
}